import { WidgetType } from '@/modules/ta/legacy/widget/widget.constants';
import { BigNumberDataService } from '@/modules/ta/legacy/widget/services/data/BigNumberDataService';
import { WidgetDataResourceFactory } from '@/modules/ta/legacy/widget/factories/WidgetDataResourceFactory';
import { DataGridDataService } from '@/modules/ta/legacy/widget/services/data/DataGridDataService';
import { TopPerformerDataService } from '@/modules/ta/legacy/widget/services/data/TopPerformerDataService';
import { CombinationChartDataService } from '@/modules/ta/legacy/widget/services/data/CombinationChartDataService';
import { LineChartDataService } from '@/modules/ta/legacy/widget/services/data/LineChartDataService';
import { PieChartDataService } from '@/modules/ta/legacy/widget/services/data/PieChartDataService';
import { BarChartDataService } from '@/modules/ta/legacy/widget/services/data/BarChartDataService';
import { GeoChartDataService } from '@/modules/ta/legacy/widget/services/data/GeoChartDataService';
import { GaugeChartDataService } from '@/modules/ta/legacy/widget/services/data/GaugeChartDataService';
import { FunnelChartDataService } from '@/modules/ta/legacy/widget/services/data/FunnelChartDataService';
import { MediaDataService } from '@/modules/ta/legacy/widget/services/data/MediaDataService';
import { AccountManagerDataService } from '@/modules/ta/legacy/widget/services/data/AccountManagerDataService';
import { GoalDataService } from '@/modules/ta/legacy/widget/services/data/GoalDataService';
import { BubbleChartDataService } from '@/modules/ta/legacy/widget/services/data/BubbleChartDataService';
import { DataSourceType } from '@/modules/core/app/constants/datasource.constants';

export class WidgetDataServiceFactory {
  /**
   * @param {Widget} widget
   * @returns {WidgetDataService}
   */
  static build(widget) {
    if (
      !widget.isAdminWidget() &&
      !widget.isMediaWidget() &&
      ((!widget.data_view_id &&
        [DataSourceType.SERVICE_DATA, DataSourceType.CATEGORY_DATA].includes(
          widget?.metadata?.data_source?.type
        )) ||
        !widget.data_type ||
        (!widget.data_source_id &&
          ![DataSourceType.ORDER_TASKS_REPORT].includes(widget?.metadata?.data_source?.type)))
    ) {
      return null;
    }

    switch (widget.type) {
      case WidgetType.TYPE_BIGNUMBER:
        return new BigNumberDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_DATAGRID:
        return new DataGridDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_TOPPERFORMER:
        return new TopPerformerDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_BARCHART:
        return new BarChartDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_BUBBLECHART:
        return new BubbleChartDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_COMBINATIONCHART:
        return new CombinationChartDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_LINECHART:
        return new LineChartDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_PIECHART:
        return new PieChartDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_GEOCHART:
        return new GeoChartDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_GAUGECHART:
        return new GaugeChartDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_FUNNELCHART:
        return new FunnelChartDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_MEDIA:
        return new MediaDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_ACCOUNTMANAGER:
        return new AccountManagerDataService(WidgetDataResourceFactory.build(widget));
      case WidgetType.TYPE_GOAL:
        return new GoalDataService(WidgetDataResourceFactory.build(widget));
      default:
        Logger.log(i18n.$t('Unsupported widget type'), Logger.LEVEL_ERROR);
    }
  }
}
